/* global ha */

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import SearchBox, {SHOW_DATEPICKER_TOOLTIP_AT_START, SHOW_DATEPICKER_TOOLTIP_AT_INTERACTION} from '@homeaway/react-searchbox-lite';

import {setSearchData} from '../../../actions/search';
import {getSearchValues} from '../../../utils/search';
import {redirect} from '../../../actions/search';
import {getPrefix} from '../../../utils/urls';

import {TESTS, getValue} from '../../../utils/abacus';
import {wrapInTest} from '../mvt/utils/mvt';

export function mapStateToProps(state) {
    const propertyType = state.destination.propertyType;

    return {
        details: state.destination.details,
        fabId: !isNaN(parseInt(propertyType, 10)) ? propertyType : null,
        lbsId: state.destination.details.lbsId,
        searchValues: state.search,
        locale: state.i18n.locale,
        site: state.config.site,
        isMobile: state.config.isMobile,
        labels: state.modules.searchBoxLite.labels,
        resetForm: state.modules.searchBoxLite.resetForm,
        abacus: state.abacus
    };
}

export function mapDispatchToprops(dispatch) {
    return {
        setSearchData,
        dispatch
    };
}

const sboxTooltipTestValuesMap = {
    1: SHOW_DATEPICKER_TOOLTIP_AT_INTERACTION,
    2: SHOW_DATEPICKER_TOOLTIP_AT_START,
    default: SHOW_DATEPICKER_TOOLTIP_AT_START
};

export class SearchBoxLiteComponent extends Component {
    static propTypes = {
        details: PropTypes.shape({
            fullName: PropTypes.string
        }),
        geoType: PropTypes.string,
        lbsId: PropTypes.string,
        searchValues: PropTypes.shape({
            departureDate: PropTypes.string,
            arrivalDate: PropTypes.string,
            children: PropTypes.number,
            adults: PropTypes.number,
            petIncluded: PropTypes.bool
        }),
        isMobile: PropTypes.bool,
        resetForm: PropTypes.bool,
        showConsolidate: PropTypes.bool
    };

    static defaultProps = {
        isMobile: false,
        resetForm: false
    };

    componentDidMount() {
        ha.userTiming.mark('primary.action.rendered');
        ha.userTiming.mark('datepicker.active');

        const cookies = document.cookie;
        const searchCookies = getSearchValues(cookies);
        const {searchValues} = this.props;

        if (!searchCookies || !searchValues) {
            return;
        }

        const differentSearchData =
            searchValues.arrivalDate !== searchCookies.arrivalDate ||
            searchValues.departureDate !== searchCookies.departureDate ||
            searchValues.adults !== searchCookies.adults ||
            searchValues.children !== searchCookies.children ||
            searchValues.petIncluded !== searchCookies.petIncluded;

        if (differentSearchData) {
            this.props.dispatch(setSearchData(searchCookies));
        }
    }

    onSubmit = ({searchPath}) => {
        this.props.dispatch(redirect(searchPath));
    };

    render = () => {
        const {
            adults,
            children,
            petIncluded,
            departureDate,
            arrivalDate
        } = this.props.searchValues;

        const {
            lbsId,
            locale,
            labels,
            site,
            resetForm,
            isMobile,
            abacus,
            fabId
        } = this.props;

        const guests = {
            adultsCount: adults,
            childrenCount: children,
            petIncluded
        };

        const destination = resetForm ? '' : this.props.details.fullName;

        const sboxTooltipTestValue = getValue(abacus, TESTS.DATEPICKER_TOOLTIP);
        const showDatePickerTooltip = sboxTooltipTestValue === 1 || sboxTooltipTestValue === 2;
        const showDatePickerTooltipMode = sboxTooltipTestValuesMap[sboxTooltipTestValue] || sboxTooltipTestValuesMap.default;

        const searchbox = (
            <SearchBox
                checkIn={arrivalDate}
                checkOut={departureDate}
                onSubmit={this.onSubmit}
                edapDatePickerLabel={'0'}
                labels={labels}
                domain={site.domain}
                typeaheadProps={{
                    site: site.name,
                    baseUrl: `https://${site.domain}`,
                    appPrefix: typeof window !== 'undefined' ? `${getPrefix()}` : ''
                }}
                {...{lbsId, destination, guests, locale, isMobile,
                    showDatePickerTooltip, showDatePickerTooltipMode, fabId}}
            />
        );

        return wrapInTest(abacus, TESTS.DEFAULT_GUESTPICKER, wrapInTest(abacus, TESTS.DATEPICKER_TOOLTIP, searchbox));
    };
}

export const SearchBoxLite = connect(mapStateToProps, mapDispatchToprops)(SearchBoxLiteComponent);

export default SearchBoxLite;
